import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../constants/queryKeys";
import UserContextService from "../services/UserContextService";
import { useMsal } from "@azure/msal-react";

const useUserContextData = () => {
  const { instance } = useMsal();
  const isLoggedIn = instance.getAllAccounts().length > 0;
  return useQuery({
    queryKey: QUERY_KEYS.getUserContextToken,
    queryFn: async () => {
      return await UserContextService.getUserContextToken();
    },
    enabled: isLoggedIn,
    refetchOnWindowFocus: false,
  });
};

export default useUserContextData;
